<script setup lang="ts">
import { UserCommunity } from '@/models/community.model';
import { User } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';

defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});
const store = useStore<ShiftCMSState & { us: UsersState }>();

const communities = computed<UserCommunity[]>(
  () => store.state.us.userCommunities,
);

function remove(id: number, userId: number) {
  store.dispatch(UsersActions.RemoveUserFromCommunity, { id, userId });
}
</script>
<template>
  <v-card class="mt-4" v-if="user.id !== -1 && communities.length">
    <v-card-title>{{
      communities.length === 1 ? 'Community' : 'Communities'
    }}</v-card-title>
    <v-card-text v-for="uc in communities" :key="uc.id">
      User is a <i v-if="uc.isTemporary">temporary </i>member of the
      <strong> {{ uc.community.name }}</strong> Community
      <v-btn
        density="compact"
        @click="() => remove(uc.community.id, user.id)"
        color="warning"
        >Remove
      </v-btn></v-card-text
    >
  </v-card>
</template>
